"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var InputField_1 = __importDefault(require("../Fields/InputField"));
var react_i18next_1 = require("react-i18next");
var Context_1 = require("../Context");
var usePasswordViewToggle_1 = __importDefault(require("../Fields/hooks/usePasswordViewToggle"));
exports.default = react_1.default.forwardRef(function ConfirmPasswordField(props, ref) {
    var _a = props.confirmTargetName, confirmTargetName = _a === void 0 ? 'newPassword' : _a, _b = props.name, name = _b === void 0 ? 'confirmPassword' : _b, validate = props.validate, rest = __rest(props, ["confirmTargetName", "name", "validate"]);
    var t = (0, react_i18next_1.useTranslation)().t;
    var _c = (0, usePasswordViewToggle_1.default)(), type = _c.type, iconName = _c.iconName, onPasswordViewToggle = _c.onPasswordViewToggle;
    var _d = (0, Context_1.useFormContext)(), validateField = _d.validateField, values = _d.values, touched = _d.touched;
    var newPassword = values[confirmTargetName];
    var confirmPasswordTouched = touched[name];
    // validateConfirmPassword is triggered before newPassword changes
    // need to manually trigger validation again after newPassword has been changed
    // could be reproduced by filling confirmPassword first then changing newPassword
    (0, react_1.useEffect)(function () {
        // validate when confirm password is touched, prevent confirm password having error initially
        if (confirmPasswordTouched) {
            setTimeout(function () {
                validateField(name);
            }, 50);
        }
    }, [
        name,
        confirmPasswordTouched,
        newPassword,
        validateField
    ]);
    var validateConfirmPassword = function (value) {
        if (value !== values[confirmTargetName]) {
            return 'The passwords do not match!';
        }
        return validate === null || validate === void 0 ? void 0 : validate(value);
    };
    return (react_1.default.createElement(InputField_1.default, __assign({ ref: ref, name: name, label: t('Confirm Password'), placeholder: t('Confirm Password'), validate: validateConfirmPassword, type: type, iconName: iconName, onIconClick: onPasswordViewToggle }, rest)));
});
